import React, { useState } from 'react';
import Button from '../../button';
import ButtonSelect from '../../button-select';
import BulkAddBonus from './bulk-add-bonus';
import AddBonus from './add-bonus';
import CloseSVG from '../../../assets/svg/close.svg';
import Modal from '../modal';

function SelectBonusOption({ isOpen, closeModal, refresh }) {
  const [option, setOption] = useState('single');
  const [showAddBonus, setShowAddBonus] = useState(false);
  const [showAddBulkBonus, setShowAddBulkBonus] = useState(false);

  function submit() {
    if (option === 'single') {
      setShowAddBonus(true);
    } else if (option === 'bulk') {
      setShowAddBulkBonus(true);
    }
  }

  return (
    <>
      {showAddBonus ? (
        <AddBonus
          isOpen={showAddBonus}
          completed={() => {
            setShowAddBonus(false);
            closeModal();
          }}
          closeModal={() => {
            setShowAddBonus(false);
          }}
          bonusData={null}
          title='Add Bonus'
          buttonText='ADD'
        />
      ) : null}
      {showAddBulkBonus ? (
      <BulkAddBonus
        isOpen={showAddBulkBonus}
        closeModal={() => setShowAddBulkBonus(false)}
        completed={() => {
          setShowAddBulkBonus(false);
          closeModal();
        }}
      />
      ) : null}
      <Modal
        scrollable={true}
        className='!max-w-[600px] !rounded-none'
        isOpen={isOpen}
        centered={true}
      >
        <div className='flex flex-col overflow-auto'>
          <div className='pl-8 pr-8 pt-4'>
            <div className='flex flex-row justify-between items-center'>
              <span className='header-4'>Select bonus upload option</span>
              <div className='cursor-pointer' onClick={() => closeModal()}>
                <img src={CloseSVG} alt='close' />
              </div>
            </div>
          </div>
          <hr className='divider' />
          <div className='flex flex-col items-center w-full gap-3'>
            <span className='text-[15px] -mb-6'>
              Select your desired option to add bonus
            </span>
            <div className='flex flex-col justify-center h-full min-h-[400px] max-w-[85%] w-full'>
              <ButtonSelect
                title={'Add Single Bonus'}
                subtitle={'Add bonus one after the other'}
                isActive={option === 'single'}
                onClick={() => setOption('single')}
              />

              <ButtonSelect
                title={'Import Employee Bonuses'}
                subtitle={
                  'Import bonuses using a pre-defined XLSX template'
                }
                isActive={option === 'bulk'}
                onClick={() => setOption('bulk')}
                className='mt-8'
              />

              <div className='w-full mt-[20px]'>
                <Button text='NEXT' type='submit' onClick={() => submit()} />
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default SelectBonusOption;
